import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { WorkCalender } from "./entity/work-calender.entity";
import { WorkCalenderAdapter } from "./work-calender.adapter";
import { WorkCalenderController } from "./work-calender.controller";
import { WorkCalenderService } from "./work-calender.service";

@Module({
    imports: [
      TypeOrmModule.forFeature([WorkCalender]),
    ],
    controllers: [WorkCalenderController],
    providers: [WorkCalenderService, WorkCalenderAdapter, ApplicationExceptionHandler],
    exports: [WorkCalenderService]
  })
  export class WorkCalenderModule {}